import { apiSlice } from "../../stores/base/api-slice";

interface CustomerOrdersResponse {
	totalPages: number;
	count: number;
	items: CustomerOrdersModel[];
	pageIndex: number;
}

export interface CustomerOrdersModel {
	id: string;
	lastPaymentDate: string;
	nextDueDate: string;
	orderNumber: string;
	orderStatus: string;
	paymentStatus: string;
	productName: string;
}

export interface OrderDetailsResponse {
	id: string;
	productName: string;
	images: any[];
	activeDuration: number;
	batteryType: string;
	durationOfPaymentsInMonths: number;
	totalPackageCost: number;
	amountPaid: number;
	amountLeft: number;
	orderNumber: string;
	deliveryAddress: string;
	orderEvents: OrderEvent[];
}

export interface OrderEvent {
	name: string;
	timestamp: string;
}

const customerOrdersEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getCustomerOrders: builder.query<CustomerOrdersResponse, { page: number; pageSize: number }>({
			providesTags: ["CustomerOrders"],
			query: params => ({
				url: `/orders/payment-status?page=${params.page}&pageSize=${params.pageSize}`,
				method: "GET",
			}),
		}),
		getCustomerOrderDetails: builder.query<OrderDetailsResponse, { orderId: string }>({
			providesTags: ["CustomerOrders"],
			query: params => ({
				url: `/orders/payment-status/${params.orderId}`,
				method: "GET",
			}),
		}),
		downloadInvoice: builder.query({
			query: params => ({
				url: `/orders/payment-status/${params.orderId}/download`,
				responseHandler: ( response: Response) => {
					return response.blob();
				},
			}),
		}),
	}),
});

export const { useGetCustomerOrdersQuery, useGetCustomerOrderDetailsQuery, useLazyDownloadInvoiceQuery } = customerOrdersEndpoints;
